<script>
import { addKitItem } from "@/api/store/ProductsService.js";

import KitItemForm from "./KitItemForm.vue";
export default {
  components: {
    KitItemForm
  },
  data() {
    return {
      item: {
        nkrCode: "",
        productId: "",
        quantity: 0,
        line: "",
        priceType: "discount",
        productDiscountType: "percentage",
        productDiscountValue: 0
      }
    };
  },
  props: {
    kitCode: {
      type: String,
      required: true
    }
  },
  methods: {
    submit(newItem) {
      addKitItem(this.kitCode, newItem)
        .then(() => {
          this.$toast.open({
            message: `The kit item ${newItem.code} was created`,
            type: "success",
            position: "top-right"
          });
          this.$emit("kitItemAdded");
        })
        .catch(() => {
          this.$toast.open({
            message: `Error creating kit item ${newItem.code}`,
            type: "error",
            position: "top-right"
          });
        });
    }
  }
};
</script>
<template>
  <BaseModal id="kit-product-modal" :value="true" @input="$emit('close')">
    <template v-slot:header>
      New Item
    </template>
    <div class="flex flex-col w-full">
      <KitItemForm v-model="item" @submit="submit">
        <button
          class="btn btn-success-button w-20 flex justify-center items-center"
        >
          create
        </button>
      </KitItemForm>
      <div></div>
    </div>
  </BaseModal>
</template>
<style lang="scss">
#kit-product-modal {
  .modal-content {
    max-width: 900px;
    height: fit-content;
    max-height: 100%;
  }
}
</style>
